/**
 * Side-by-side migration switch (owner approval, 2026-10-20).
 *
 * A screen that has a Decision Workspace version (docs/ui-kit-plan.md) keeps its ported original
 * as the DEFAULT. Adding `?ui=workspace` to the address shows the workspace version instead, so
 * the owner can compare the two in the same running app and approve each screen on its own
 * (CLAUDE.md 1.2). Once a screen is approved, its original and this switch are deleted.
 */
export function isWorkspaceUi(search: string): boolean {
  return new URLSearchParams(search).get('ui') === 'workspace';
}
